export const BOOK_DEMO_SESSION_KEY = 'book_demo_email_approved';

export function approveBookDemoEmail(email: string) {
  sessionStorage.setItem(BOOK_DEMO_SESSION_KEY, email.trim().toLowerCase());
}

export function getApprovedBookDemoEmail() {
  const value = sessionStorage.getItem(BOOK_DEMO_SESSION_KEY);
  if (!value || value === 'true') return null;
  return value;
}

export function isBookDemoEmailApproved() {
  return getApprovedBookDemoEmail() !== null;
}

export function clearBookDemoEmailApproval() {
  sessionStorage.removeItem(BOOK_DEMO_SESSION_KEY);
}
